export default "__VITE_ASSET__BdvhJTGJ__"